import {
  findListingEntity,
  findListingVariantEntity,
} from './entityReadHelpers';

const readDraftDomains = (products, productId, variantId, channelId) => {
  if (!productId || !channelId) return null;

  if (variantId) {
    const listingVariant = findListingVariantEntity(products, variantId, channelId);
    return listingVariant?.draftDomains || null;
  }

  const listing = findListingEntity(products, {
    masterProductId: productId,
    channelId,
  });
  return listing?.draftDomains || null;
};

export default readDraftDomains;
